import type { FrontendModule } from '@/lib/types'
import { InboxPage } from './pages/InboxPage'
import { VerificationListPage } from './pages/VerificationListPage'
import { VerificationPage } from './pages/VerificationPage'
import { RoutingPage } from './pages/RoutingPage'
import { AiInboxWidget } from './widgets/AiInboxWidget'

/**
 * Moduł `documents` — skrzynka wpływu, weryfikacja pisma i tablica dekretacji.
 *
 * Nawigacja NIE jest deklarowana tutaj: pochodzi z `/api/me/context`
 * (manifest backendu, grupa „OBIEG DOKUMENTÓW"). Trasy muszą się zgadzać
 * z `NavItem.route`: /dokumenty/skrzynka, /dokumenty/weryfikacja, /dokumenty/dekretacja.
 */
export const documentsModule: FrontendModule = {
  key: 'documents',
  routes: [
    { path: 'dokumenty/skrzynka', element: <InboxPage /> },
    { path: 'dokumenty/weryfikacja', element: <VerificationListPage /> },
    { path: 'dokumenty/weryfikacja/:documentId', element: <VerificationPage /> },
    { path: 'dokumenty/dekretacja', element: <RoutingPage /> },
  ],
  dashboardWidgets: [
    { id: 'documents.ai-inbox', column: 'main', order: 10, component: AiInboxWidget },
  ],
}

export default documentsModule
